const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://yn7yegf2h8.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://z15kn8zoyi.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://r1x5h58vt2.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.datainsights.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://dnjv875rxk.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;